import React, { ReactElement } from 'react';

import { observer } from 'mobx-react';

import {
  GridTableCell,
  GridTableRow,
} from '../../../../../shared/components/table-components';
import { SortButtons } from '../../../../../shared/components/buttons';
import classes from './TitleRow.module.scss';
import { paymentIssueStore } from '../../../../stores/paymentIssueStore';
import { PAYMENT_ISSUE_COLUMN, PaymentIssueColumn } from '../PaymentIssueTable.settings';
import { SOLUTION_TYPE } from '../../../../../shared/constants/user-info/solutionType';

type TitleRowProps = {
  visibleColumns: PaymentIssueColumn[];
};

const TitleRow = observer(({ visibleColumns }: TitleRowProps) => {
  const { filterMethods } = paymentIssueStore;
  const { handleSort, getIsSortedBy, filterData } = filterMethods;
  const { solutionType } = filterData;

  const isNutrition = solutionType === SOLUTION_TYPE.NUTRITION;

  const renderColumnsInfo: Record<PaymentIssueColumn, ReactElement> = {
    [PAYMENT_ISSUE_COLUMN.NAME]: (
      <GridTableCell>
        <SortButtons
          fieldName="CUSTOMER_NAME"
          onSort={handleSort}
          getIsActive={getIsSortedBy}
        >
          Name
        </SortButtons>
      </GridTableCell>
    ),
    [PAYMENT_ISSUE_COLUMN.SOLUTION]: (
      <GridTableCell>
        <SortButtons
          fieldName="SOLUTION_TYPE"
          onSort={handleSort}
          getIsActive={getIsSortedBy}
        >
          Solution
        </SortButtons>
      </GridTableCell>
    ),
    [PAYMENT_ISSUE_COLUMN.COACH]: (
      <GridTableCell>
        <SortButtons
          fieldName="COACH_NAME"
          onSort={handleSort}
          getIsActive={getIsSortedBy}
        >
          Coach
        </SortButtons>
      </GridTableCell>
    ),
    [PAYMENT_ISSUE_COLUMN.SUBSCRIPTION]: (
      <GridTableCell>
        <SortButtons
          fieldName="SUBSCRIPTION_NAME"
          onSort={handleSort}
          getIsActive={getIsSortedBy}
        >
          {isNutrition ? 'Subscription' : 'Subscription/Service'}
        </SortButtons>
      </GridTableCell>
    ),
    [PAYMENT_ISSUE_COLUMN.PRICE]: (
      <GridTableCell>
        <SortButtons fieldName="PRICE" onSort={handleSort} getIsActive={getIsSortedBy}>
          Price
        </SortButtons>
      </GridTableCell>
    ),
    [PAYMENT_ISSUE_COLUMN.ACTIVE_SINCE]: (
      <GridTableCell>
        <SortButtons
          fieldName="ACTIVE_SINCE"
          onSort={handleSort}
          getIsActive={getIsSortedBy}
        >
          Active Since
        </SortButtons>
      </GridTableCell>
    ),
    [PAYMENT_ISSUE_COLUMN.DATE_OF_UPDATE]: (
      <GridTableCell justify="end">Date of Update</GridTableCell>
    ),
  };

  return (
    <GridTableRow variant="unstyled" className={classes.titleRow}>
      {visibleColumns.map((column) => (
        <React.Fragment key={column}>{renderColumnsInfo[column]}</React.Fragment>
      ))}
    </GridTableRow>
  );
});

export { TitleRow };
